module.exports = __webpack_public_path__ + "static/media/Slice3@2x.d679e4c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_147/img/Slice3@2x.png
// module id = 1408
// module chunks = 0